export default {"src":"/_next/static/media/RDNT.0c8c6782.svg","height":18,"width":18};